module.exports = __webpack_public_path__ + "img/techsoup_together_logo_orange_white.f71c9313.png";